import { css } from 'styled-components';
import { isDefined } from '../helpers/defined';
import { NIGHTINGALE_BLACK } from '../colors';
import { getDefined } from '../helpers/common';
import { size } from '../style/size';
import { height } from '../style/height';
import { width } from '../style/width';
export const svgSizeStyle = css`
  box-sizing: content-box;
  ${({
  size: value
}) => isDefined(value) && size(value)}
  ${({
  width: value
}) => isDefined(value) && width(value)}
  ${({
  height: value
}) => isDefined(value) && height(value)}
`;
export const svgColorStyle = css`
  transition: transform 0.3s ease-in-out, fill 0.15s ease-out;
  ${({
  color = NIGHTINGALE_BLACK
}) => color && `fill: ${color};`}
  ${({
  colorHover,
  colorActive
}) => getDefined(colorHover, colorActive) && `
    &:hover {
      fill: ${getDefined(colorHover, colorActive)};
    }
  `}
  & .tui-color-secondary {
    transition: fill 0.15s ease-out;
    ${({
  colorSecondary
}) => colorSecondary && `fill: ${colorSecondary};`}
    ${({
  colorSecondaryHover,
  colorSecondaryActive
}) => getDefined(colorSecondaryHover, colorSecondaryActive) && `
      &:hover {
        fill: ${getDefined(colorSecondaryHover, colorSecondaryActive)};
      }
    `}
  }
`;
export const svgDisplayStyle = css`
  display: inline-block;
  vertical-align: text-bottom;
  ${({
  flex
}) => flex && `
    display: inline-flex;
    justify-content: center;
    align-items: center;
  `}
`;
export const svgPointerStyle = css`
  ${({
  pointer
}) => pointer && `cursor: pointer;`}
`;
export const svgKeys = ['color', 'colorHover', 'colorActive', 'colorSecondary', 'colorSecondaryHover', 'colorSecondaryActive', 'size', 'width', 'height', 'pointer', 'flex'];